import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetVehicleTypes } from 'core/Store/vehicleTypes/actions';
import { selectVehicleTypes } from 'core/Store/vehicleTypes/selectors';
import { VehicleType } from 'core/types/vehicleType';

let loading = false;

export default function useVehicleTypeSelectable() {
  const showErrorNotification = useErrorNotifications();
  const [vehicleTypes, dispatch] = useSubstate(selectVehicleTypes);

  useEffect(() => {
    if (loading || vehicleTypes.length) {
      return;
    }

    loading = true;

    client()
      .get<VehicleType[]>(`vehicle_types`)
      .then(response => response.data)
      .then(types => dispatch(new SetVehicleTypes(types)))
      .catch(showErrorNotification);
  }, [dispatch, showErrorNotification, vehicleTypes.length]);

  return vehicleTypes;
}
